// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1qybB","content":"styles_content__17wmY"};